enum EPractitionerStatus {
  allActive = -2,
  inactive = 0,
  active = 1,
  payAsYouGo = 2
}

export default EPractitionerStatus;
